import React, { Component } from "react";
import Product from "./Product";
import tShirt from "../../imgs/product.png";

export default class Store extends Component {
  render() {
    return (
      <div>
        <div className="shop">
          <h6 className="text-lg text-dark text-bold text-center mb-5">Shop</h6>

          <div className="shop-container d-flex">
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
            <Product name="DG Labs v1 Shirt" price="$30" img={tShirt} />
          </div>
        </div>
      </div>
    );
  }
}
